
export const getPages = ({ pagesReducer: { pages = [] } = {} }) => pages;
export const getPageFilter = ({ pagesReducer: { filter = {} } = {} }) => filter;
export const getPagesCount = ({ pagesReducer: { count = 0 } = {} }) => count;
export const getCommonFilter = ({ blogsReducer: { common_filter = {} } = {} }) => common_filter;